export default __webpack_public_path__ + "static/media/icon-check-active.8aa85fcd.svg";